import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=3adb1bd0&"
import script from "./Routes.vue?vue&type=script&lang=js&"
export * from "./Routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports